import { useEffect } from 'react';

import { useMainActions } from '../store';
import { ITEM_TYPE } from '../const';

export const useAutoExpandActiveSubmenu = (navigationItems, activePath) => {
  const mainActions = useMainActions();

  useEffect(() => {
    const activeSubmenu = navigationItems.find((item) => {
      if (item.type === ITEM_TYPE.submenu) {
        return item.items.some((subItem) => activePath.startsWith(subItem.path));
      }

      return false;
    });

    if (activeSubmenu && mainActions.getExpandedSubmenu() !== activeSubmenu.id) {
      mainActions.toggleSubmenu(activeSubmenu.id);
    }
  }, [navigationItems, activePath, mainActions]);
};
